import apiClient from "../../services/apiClient";

//................. Sidebar Api's...................//

export const getChangePassword = (data) =>
  apiClient.post("/Auth/change-password", data);

//................. Admin Profile Api's...................//

export const getAdminProfileData = () => apiClient.get("/Profile", {});

export const updateAdminProfileData = (data) =>
  apiClient.post("/Profile", data);

export const updateAdminProfilPic = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return apiClient.post("/Profile/avatar", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

//................. Dashboard Api's...................//

export const getDashboardData = () => apiClient.get("/admin/dashboard", {});

export const getDashboardDataWithRange = (
  period,
  fromDate = null,
  toDate = null,
) => {
  const params = { Period: period };
  if (period === "custom" && fromDate && toDate) {
    params.FromDate = fromDate;
    params.ToDate = toDate;
  }
  return apiClient.get("/admin/dashboardwithrange", { params });
};

export const getDashboardReport = () => apiClient.get("/admin/reports", {});

//................. Users  Api's...................//

export const getStateWithApi = () => apiClient.get("/master/states", {});

export const getMasterPincode = (pincode) =>
  apiClient.get(`/master/pincode/${pincode}`, {});

export const getUsers = (params) => apiClient.get("/admin/users", { params });

export const createUser = (data) => apiClient.post("/admin/users", data);

export const getUserById = (id) => apiClient.get(`/admin/users/${id}`);

export const updateUserById = (id, data) =>
  apiClient.post(`/admin/users/${id}`, data);

export const toggleUserStatusById = (id, data) =>
  apiClient.post(`/admin/users/${id}/status`, data);

export const resendPasswordToUser = (id) =>
  apiClient.post(`/admin/users/${id}/resend-password`);

export const getUserLedgerById = (id) =>
  apiClient.get(`/admin/users/${id}/ledger`);

export const userFundTransferById = (id, data) =>
  apiClient.post(`/admin/users/${id}/fund-transfer`, data);

//................. Fund Request  Api's...................//

export const getFundRequestStats = () =>
  apiClient.get("/admin/fund-requests/stats");

export const getFundRequest = (params) =>
  apiClient.get("/admin/fund-requests", { params });

export const fundRequestApproval = (id) =>
  apiClient.post(`/admin/fund-requests/${id}/approve`);

export const fundRequestRejection = (id, data) =>
  apiClient.post(`/admin/fund-requests/${id}/reject`, data);

//................. Subscriptions  Api's...................//

export const getSubscriptionList = (params) =>
  apiClient.get("/admin/subscriptions", { params });

export const cancelSubscriptionData = (id, data) =>
  apiClient.post(`/admin/subscriptions/${id}/cancel`, data);

export const extendSubscriptionData = (id, data) =>
  apiClient.post(`/admin/subscriptions/${id}/extend`, data);

//................. Packages  Api's...................//

export const getPackageList = () => apiClient.get("/admin/packages", {});

export const togglePackageStatusById = (id, isActive) =>
  apiClient.post(`/admin/packages/${id}/status?IsActive=${isActive}`);

export const getPackageFeaturesList = () =>
  apiClient.get("/master/package-features", {});

export const createPackages = (data) =>
  apiClient.post("/admin/packages/create", data);

export const deletePackagesById = (id) =>
  apiClient.post(`/admin/packages/${id}/delete`);

export const getPackageById = (id) => apiClient.get(`/admin/packages/${id}`);

export const updatePackageById = (id, data) =>
  apiClient.post(`/admin/packages/${id}/update`, data);

//................. Amenities Api's...................//

export const getAmenitiesList = () => apiClient.get("/admin/master-amenities");

export const toggleAmenitiesStatus = (id) =>
  apiClient.post(`/admin/master-amenities/${id}/toggle`);

export const createAmenities = (data) =>
  apiClient.post("/admin/master-amenities/add", data);

export const getAmenitiesById = (id) =>
  apiClient.get(`/admin/master-amenities/${id}`);

export const updateAmenitiesById = (id, data) =>
  apiClient.post(`/admin/master-amenities/${id}/update`, data);

export const deleteAmenitiesById = (id) =>
  apiClient.post(`/admin/master-amenities/${id}/delete`);

//................. Payment Mode  Api's...................//

export const getPaymentModeList = () => apiClient.get("/admin/payment-modes");

export const getPaymentModeById = (id) =>
  apiClient.get(`/admin/payment-modes/${id}`);

export const createUpdatePaymentModeById = (data) =>
  apiClient.post("/admin/payment-modes/upsert", data);

export const togglePaymentModeById = (id, status) =>
  apiClient.post(`/admin/payment-modes/${id}/toggle?isEnabled=${status}`);

export const removePaymentModeById = (id) =>
  apiClient.post(`/admin/payment-modes/${id}/delete`);

export const createUpdatePaymentModeFields = (data) =>
  apiClient.post("/admin/payment-modes/fields/upsert", data);

export const removePaymentModeFieldsById = (id) =>
  apiClient.post(`/admin/payment-modes/fields/${id}/delete`);

//................. Payment Instruments  Api's...................//

export const getPaymentInstrumentData = () =>
  apiClient.get("/admin/payment-instruments");

export const getPaymentInstrumentById = (id) =>
  apiClient.get(`/admin/payment-instruments/${id}`);

export const addUpdatePaymentInstrument = (data) =>
  apiClient.post("/admin/payment-instruments/upsert", data);

export const togglePaymentInstrumentStatus = (id, status) =>
  apiClient.post(`/admin/payment-instruments/${id}/toggle?isEnabled=${status}`);

export const deletePaymentInstrumentById = (id) =>
  apiClient.post(`/admin/payment-instruments/${id}/delete`);

//................. Payment Gateway Api's...................//

export const masterPaymentGatewayList = () =>
  apiClient.get("/master/payment-gateways");

export const getPaymentGatewayList = () =>
  apiClient.get("/admin/payment-gateways");

export const createPaymentGateway = (data) =>
  apiClient.post("/admin/payment-gateways/upsert", data);

export const togglePayGatewayIsActive = (id, status) =>
  apiClient.post(`/admin/payment-gateways/${id}/toggle?isActive=${status}`);

export const togglePayGatewayIsIntent = (id, status) =>
  apiClient.post(
    `/admin/payment-gateways/${id}/intent/toggle?isActive=${status}`,
  );
export const getPaymentGatewayRouting = () =>
  apiClient.get("/admin/payment-gateways/routing");

export const updatePaymentGatewayRouting = (data) =>
  apiClient.post("/admin/payment-gateways/routing/update", data);

export const togglePayGatewayRoutingIsActive = (id, status) =>
  apiClient.post(
    `/admin/payment-gateways/routing/toggle/${id}?isActive=${status}`,
  );

//................. System Settings  Api's...................//

export const getSystemSettingData = () =>
  apiClient.get("/admin/system-settings");

export const saveCompanyInfo = (data) =>
  apiClient.post("/admin/system-settings", data);

export const getSupportContactsList = () =>
  apiClient.get("/admin/support-contacts");

export const createSupportContactsList = (data) =>
  apiClient.post("/admin/support-contacts-add", data);

export const updateSupportContactsList = (id, data) =>
  apiClient.post(`/admin/support-contacts-update/${id}`, data);

export const deleteSupportContactsList = (id) =>
  apiClient.post(`/admin/support-contacts-delete/${id}`);

export const getSystemSettingfeatureToggleList = () =>
  apiClient.get("/admin/feature-toggles");

export const updateSystemSettingFeatureToggle = (data) =>
  apiClient.post("/admin/feature-toggles", data);

//................. Website Settings  Api's...................//

export const getDomainSettingData = () =>
  apiClient.get("/admin/domain-settings");

export const saveDomainSettingData = (data) =>
  apiClient.post("/admin/domain-settings/save", data);

export const getSocialMediaSettingList = () =>
  apiClient.get("/admin/domain-settings/social-media");

export const createSocialMedia = (data) =>
  apiClient.post("/admin/domain-settings/social-media/insertupdate", data);

export const getSocialMediaById = (id) =>
  apiClient.get(`/admin/domain-settings/social-media/${id}`);

export const deleteSocialMediaById = (id) =>
  apiClient.post(`/admin/domain-settings/social-media/delete/${id}`);

export const getOGTagsSettingList = () =>
  apiClient.get("/admin/domain-settings/og-tags");

export const createOGTags = (data) =>
  apiClient.post("/admin/domain-settings/og-tags/insertupdate", data);

export const getOGTagsById = (id) =>
  apiClient.get(`/admin/domain-settings/og-tags/${id}`);

export const deleteOGTagsById = (id) =>
  apiClient.post(`/admin/domain-settings/og-tags/delete/${id}`);

export const getTwitterCardsTagsList = () =>
  apiClient.get("/admin/domain-settings/twitter-card-tags");

export const createTwitterCardsTags = (data) =>
  apiClient.post("/admin/domain-settings/twitter-card-tags/insertupdate", data);

export const getTwitterCardsTagsById = (id) =>
  apiClient.get(`/admin/domain-settings/twitter-card-tags/${id}`);

export const deleteTwitterCardsTagsById = (id) =>
  apiClient.post(`/admin/domain-settings/twitter-card-tags/delete/${id}`);
